import { render, staticRenderFns } from "./AllSpaceTemperatureHumidity.vue?vue&type=template&id=5f6512a4&scoped=true&"
import script from "./AllSpaceTemperatureHumidity.vue?vue&type=script&lang=js&"
export * from "./AllSpaceTemperatureHumidity.vue?vue&type=script&lang=js&"
import style0 from "./AllSpaceTemperatureHumidity.vue?vue&type=style&index=0&id=5f6512a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6512a4",
  null
  
)

export default component.exports